import React, { useEffect, useState } from 'react';

import MainMenu from 'Jsx/MainMenu/containers';
import MainFooter from 'Jsx/MainFooter';

import parseQueryStrings from 'Jsx/Utils/parseQueryStrings';
import { InitialStateResult } from 'Jsx/Utils/getBaseInitialState';
import { useTranslation } from 'Jsx/Shared/Hooks/useTranslation';

import CoursesInBundleProvider from 'Jsx/ContextApis/CoursesInBundle';
import { useMe } from 'ContextApis/AuthContext';

import { PricesContextProvider } from './Context/Prices';

import SEOStructuredData from './components/SEOStructuredData';

import AppV3 from './sections/v3/main/App';
import { COURSE_DETAIL_PAGE_KEY } from './constants';
import localeEsV3 from './sections/v3/i18n/localeEs';
import localePtV3 from './sections/v3/i18n/localePt';
import useCanEnrollWithFirstEnroll from './hooks/useCanEnrollWithFirstEnroll';

export type ExtraState = {};

export type AppProps = {};

const App: React.FC<InitialStateResult<AppProps & ExtraState>> = props => {
  const { me } = useMe();
  const [campaignSlug, setCampaignSlug] = useState<string>();
  const { addResourceBundle, t } = useTranslation();
  const { canEnrollToCourseFreemium } = useCanEnrollWithFirstEnroll();

  const APP = AppV3;

  const { redesignEnabled } = props.course;

  addResourceBundle({
    es: {
      [COURSE_DETAIL_PAGE_KEY]: localeEsV3.es,
    },
    pt: {
      [COURSE_DETAIL_PAGE_KEY]: localePtV3.pt,
    },
  });

  const onClickRedirectAuthPageV2 = (viewPage: string) => {
    if (viewPage === 'REGISTER') {
      window.location.href = `/registro/?next=/registro-extra/?enrollmenturl=${props.course.enrollmentUrl}`;
    } else {
      window.location.href = '/entrar/';
    }
  };

  useEffect(() => {
    const qs = parseQueryStrings(location.search);

    if (qs && qs.from_campaign) {
      setCampaignSlug(qs.from_campaign);
    }
  }, []);

  return (
    <React.Fragment>
      <MainMenu
        mode="solid"
        organization={me?.organization}
        countryPrefix={props.countryPrefix}
        categories={props.categories}
        showHubLinks={false}
        dontCheckForPagePromo
        onClickRedirectAuthPageV2={
          canEnrollToCourseFreemium ? onClickRedirectAuthPageV2 : undefined
        }
        isDisabledButtonLogin={canEnrollToCourseFreemium}
        loginRegisterSwitcherProps={{
          registerButtonLabel: canEnrollToCourseFreemium
            ? t('FREE_TRIAL')
            : undefined,
        }}
      />

      <SEOStructuredData course={props.course} />

      <CoursesInBundleProvider campaignSlug={campaignSlug}>
        <PricesContextProvider id={props.course.originalId.toString()}>
          <APP
            {...props}
            isBundleCampaign={!!campaignSlug}
            user={me}
            isLegacyUI={!redesignEnabled}
          />
        </PricesContextProvider>
      </CoursesInBundleProvider>

      {!me?.hasOrganization && (
        <MainFooter countryPrefix={props.countryPrefix} />
      )}
    </React.Fragment>
  );
};

export default App;
